// Center each desktop dropdown under its trigger, clamping to a 16px viewport inset.
const header = document.querySelector('#header-component');
if (header) {
  let frame;
  const widths = { shopall: 1200, kbeauty: 1200, wellness: 640, about: 544, more: 560 };
  const position = (trigger, panel, kind) => {
    if (!trigger || !panel || !trigger.getClientRects().length) return;
    const bar = header.querySelector('.header__row--top');
    const r = trigger.getBoundingClientRect();
    const width = Math.min(widths[kind], window.innerWidth - 32);
    const left = Math.max(16, Math.min(r.left + r.width / 2 - width / 2, window.innerWidth - 16 - width));
    const parent = panel.offsetParent;
    const origin = parent?.getBoundingClientRect() || { left: 0, top: 0 };
    panel.style.setProperty('--ww-dropdown-left', `${left - origin.left}px`);
    panel.style.setProperty('--ww-dropdown-top', `${bar.getBoundingClientRect().bottom - origin.top}px`);
    panel.style.setProperty('--ww-dropdown-width', `${width}px`);
    panel.dataset.wwDropdownKind = kind;
  };
  const update = () => {
    frame = null;
    if (window.innerWidth < 990 || header.dataset.menuStyle !== 'menu') return;
    for (const item of header.querySelectorAll('header-menu .menu-list__list-item:not([slot="overflow"])')) {
      const trigger = item.querySelector(':scope > .menu-list__link');
      const panel = item.querySelector(':scope > .menu-list__submenu');
      position(trigger, panel, trigger?.textContent.trim() === 'Wellness' ? 'wellness' : 'shopall');
    }
    position(header.querySelector('.ww-kbm--desktop .ww-kbm-trigger'), header.querySelector('.ww-kbm--desktop .ww-kbm-panel'), 'kbeauty');
    position(header.querySelector('.ww-utility-menu--desktop .ww-utility-menu__trigger'), header.querySelector('.ww-utility-menu--desktop .ww-utility-menu__panel'), 'about');
    for (const host of header.querySelectorAll('header-menu overflow-list')) {
      position(host.querySelector('[data-ww-more-trigger]'), host.shadowRoot?.querySelector('[part="overflow"]'), 'more');
    }
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  new MutationObserver(schedule).observe(header, { subtree: true, childList: true, attributes: true, attributeFilter: ['open','aria-expanded','slot','data-overflow-expanded','data-menu-style'] });
  new ResizeObserver(schedule).observe(header.querySelector('.header__row--top'));
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  header.addEventListener('pointerover', schedule, { passive: true });
  header.addEventListener('click', schedule);
  header.addEventListener('focusin', schedule);
  document.fonts.ready.then(schedule);
  schedule();
}
